/* eslint-disable no-undef */
export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
        <!-- Navigation -->
        <div class="swiper-arrows container">
          <div class="swiper-arrows__button swiper-arrows__button--prev" tabindex="0" role="button" aria-label="Previous slide">
            <span></span>
          </div>
          <div class="swiper-arrows__button swiper-arrows__button--next" tabindex="0" role="button" aria-label="Next slide">
            <span></span>
          </div>
        </div>
         <!-- pagination -->
        <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach((slide, i) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    function autoPlaySettings() {
      if (widgetData.length > 1) {
        return { delay: 8000 }; // this line enable the autoplay and timing
      }
      $('.swiper-pagination').remove();
      $('.swiper-arrows').remove();
      return false;
    }

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: '.swiper-arrows__button--next',
        prevEl: '.swiper-arrows__button--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoPlaySettings(),
      allowSlideNext: autoPlaySettings(),
      allowSlidePrev: autoPlaySettings(),
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then((response) => {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      if (window.innerWidth < 768) {
        $(`#${widgetName}`).parent().next().css('padding-top', '25vw');
      } else {
        $(`#${widgetName}`).parent().next().css('padding-top', '100px');
      }
      $(`#${widgetName}`).remove();
    }
  });
}
